export enum SortDirections {
  unknow = 0,
  ascending = 1,
  descending = 2
}
